import script from "./modules-choice.vue?vue&type=script&setup=true&lang=ts"
export * from "./modules-choice.vue?vue&type=script&setup=true&lang=ts"

import "./modules-choice.vue?vue&type=style&index=0&id=8377b42a&scoped=true&lang=scss"

import exportComponent from "D:\\wamp\\www\\GSALT\\gsalt-matters-ibd-denmark\\web\\modules\\vuejs\\vuejs-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8377b42a"]])

export default __exports__